import { apiClient } from './client';

export const authApi = {
  forgotPassword: async (email: string): Promise<{ message: string }> => {
    return apiClient.post('/auth/forgot-password', { email }, { skipAuth: true });
  },

  resetPassword: async (token: string, new_password: string): Promise<{ message: string }> => {
    return apiClient.post('/auth/reset-password', { token, new_password }, { skipAuth: true });
  }
};
